module.exports={
	"Form": "PhysicalAssetMaterialViewManifest",
	"Scope": "PhysicalAssetMaterial-View",
	"Descriptors":
	{
		"PhysicalAssetMaterialDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetMaterial-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-Identity",
				"Group": "PhysicalAssetMaterial-View-Identity"
			}
		},
		"PhysicalAssetMaterialDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-Details",
				"Group": "PhysicalAssetMaterial-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetMaterialDetails.Material":
		{
			"Name": "Material",
			"Hash": "PhysicalAssetMaterial-View-Material",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-Details",
				"Group": "PhysicalAssetMaterial-View-Details"
			}
		},
		"PhysicalAssetMaterialDetails.Description":
		{
			"Name": "Description",
			"Hash": "PhysicalAssetMaterial-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "PhysicalAssetMaterial-View-Details",
				"Group": "PhysicalAssetMaterial-View-Details"
			}
		},
		"PhysicalAssetMaterialDetails.IDPhysicalAssetMaterial":
		{
			"Name": "IDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-View-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.GUIDPhysicalAssetMaterial":
		{
			"Name": "GUIDPhysical Asset Material",
			"Hash": "PhysicalAssetMaterial-View-GUIDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetMaterial-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetMaterial-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetMaterial-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		},
		"PhysicalAssetMaterialDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetMaterial-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetMaterial-View-DataAudit",
				"Group": "PhysicalAssetMaterial-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetMaterial-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetMaterial-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetMaterial-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetMaterial-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetMaterial-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetMaterial-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
